<template>
  <div class="min-h-screen bg-white flex flex-col">
    <TrustBar />
    <main class="flex-1 pt-[120px] pb-12">
      <div class="max-w-4xl mx-auto px-4">
        <h1 class="text-3xl font-bold text-gray-900 mb-8">Besoin d'aide ?</h1>

        <div class="space-y-4">
          <details class="bg-gray-50 rounded-2xl p-6">
            <summary class="font-semibold text-gray-900 cursor-pointer">Comment recevoir mon code ?</summary>
            <p class="mt-4 text-gray-600">Une fois le paiement confirmé, le code est envoyé instantanément par email.</p>
          </details>

          <details class="bg-gray-50 rounded-2xl p-6">
            <summary class="font-semibold text-gray-900 cursor-pointer">Le paiement est-il sécurisé ?</summary>
            <p class="mt-4 text-gray-600">Oui, nous utilisons Stripe et PayPal, deux prestataires certifiés PCI-DSS. Vos informations de paiement ne sont jamais stockées sur nos serveurs.</p>
          </details>

          <details class="bg-gray-50 rounded-2xl p-6">
            <summary class="font-semibold text-gray-900 cursor-pointer">Quels modes de paiement acceptez-vous ?</summary>
            <p class="mt-4 text-gray-600">Nous acceptons les paiements par carte bancaire (via Stripe) et les paiements PayPal (Visa, Mastercard, etc.).</p>
          </details>

          <details class="bg-gray-50 rounded-2xl p-6">
            <summary class="font-semibold text-gray-900 cursor-pointer">Puis-je obtenir un remboursement ?</summary>
            <p class="mt-4 text-gray-600">En raison de la nature numérique de nos produits, les ventes sont définitives une fois le code envoyé. Cependant, si un code est défectueux, nous le remplaçons sous 48h.</p>
          </details>

          <details class="bg-gray-50 rounded-2xl p-6">
            <summary class="font-semibold text-gray-900 cursor-pointer">Le code a-t-il une date d'expiration ?</summary>
            <p class="mt-4 text-gray-600">Cela dépend du fournisseur du code. Vérifiez les conditions spécifiques à chaque produit.</p>
          </details>

          <details class="bg-gray-50 rounded-2xl p-6">
            <summary class="font-semibold text-gray-900 cursor-pointer">Je n'ai pas reçu mon email de confirmation</summary>
            <p class="mt-4 text-gray-600">Vérifiez vos spam. Si toujours absent, contactez notre support avec votre numéro de commande.</p>
          </details>
        </div>

        <div class="mt-12 p-6 bg-gray-50 rounded-2xl">
          <h2 class="text-xl font-semibold text-gray-900 mb-4">Vous ne trouvez pas de réponse ?</h2>
          <p class="text-gray-600">Notre équipe est disponible pour vous aider. Vous pouvez nous contacter en répondant directement à l'email de confirmation de commande ou en utilisant les informations de contact figurant sur vos reçus.</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
// HelpCenterPage - Page d'aide avec FAQ
</script>
